import { useSettings } from "../../../../api/useSettings";
import { useUser } from "../../../../api/useUser";
import { useHasUserRole } from "../../../canUserDo";

export const useFaultEventAccess = () => {
  const settings = useSettings();
  const user = useUser();
  const isSuperAdmin = useHasUserRole(user, "SUPER_ADMIN");
  const isAdmin = useHasUserRole(user, "ADMIN");

  if (isSuperAdmin || (isAdmin && settings.FAULT_EVENTS_ADMIN_ENABLED)) return true;

  return settings.FAULT_EVENTS_ENABLED;
};
